<template lang="pug">
    .login-page
        #login
            //- <!-- logo部分 -->
            .logo
               img(src="./login-img/leftTop.png" alt="logo")

            //- <!--表单左侧-->
            .form-left
               img(src="./login-img/form-left.png" )
            //-    <!--标题-->
            .login-title
               font 天天有网球后台管理系统
            //- <!-- 表单部分 -->
            .form-group
                el-card(shadow="never")
                    el-form(ref="loginForm", @keyup.enter.native="submit", label-position="top", :rules="rules", :model="formLogin" size="default")
                        el-form-item(prop="username" )
                            el-input(type="text" v-model="formLogin.username" class='userIput' placeholder="请输入账户名")
                                 i.fa.fa-my-userIcon(slot="prepend" style="font: unset;")
                        el-form-item(prop="password" )
                            el-input(type="password" v-model="formLogin.password" class='passIput' placeholder="请输入密码")
                                i.fa.fa-my-pwdIcon(slot="prepend" style="font: unset;")
                        el-form-item(prop="code" )
                            el-input(type="text" v-model="formLogin.code" class='authCode-input' placeholder="请输入验证码")
                                i.fa.fa-my-authCode(slot="prepend" style="font: initial;")
                                template(slot="append")
                                    img.login-code(:src="captchaPath" @click="getCaptcha()" alt="")
                        el-row.checkbox
                          el-col(:span='24' :offset="16")
                            el-checkbox(v-model="formLogin.remember" checked) 记住密码

                        el-button.button-login(size="default" :disabled="submitLoading" @click="submit" class='login-btn') 登 录

            div.copr() ©版权所有  国奥利贤（北京）体育文化发展有限公司&nbsp;|&nbsp;
                a(href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank") 主体备案号：京ICP备17013274号
        el-dialog(title="快速选择用户", :visible.sync="dialogVisible", width="400px", :modal-append-to-body='false')
            el-row(:gutter="10" style="margin: -20px 0px -10px 0px;")
                el-col(v-for="(user, index) in users" :key="index" :span="8")
                    .user-btn(@click="handleUserBtnClick(user)")
                        d2-icon(name="user-circle-o")
                        span {{user.name}}
        //- 二次认证弹窗（已绑定用户）：账密通过后验码换 token
        el-dialog(title="二次认证（TOTP 动态码）", :visible.sync="mfaVisible", width="400px", :close-on-click-modal="false", :modal-append-to-body='false', @closed="mfaCode = ''")
            .mfa-dialog-tip 账号密码已验证通过，请输入认证器 App（Microsoft Authenticator 等）当前显示的 6 位动态码
            el-input(ref="mfaInput", v-model="mfaCode", maxlength="6", placeholder="请输入 6 位数字动态码", @input="onMfaCodeInput", @keyup.enter.native="submitMfa")
            span(slot="footer")
                el-button(:disabled="mfaLoading" @click="mfaVisible = false") 取 消
                el-button(type="primary", :loading="mfaLoading", @click="submitMfa") 确 认
        //- 首次绑定弹窗（未绑定用户，强制）：setup 取二维码，扫码输入动态码绑定后进入系统
        el-dialog(title="绑定二次认证", :visible.sync="bindVisible", width="420px", :close-on-click-modal="false", :close-on-press-esc="false", :modal-append-to-body='false', @closed="resetBind")
            .mfa-qrcode(v-loading="bindRefreshing")
                img(v-if="bindInfo.qrCode", :src="bindInfo.qrCode", alt="TOTP 绑定二维码")
            .mfa-guide
                .mfa-guide-title 使用说明
                ol.mfa-guide-list
                    li 请先下载 TOTP 认证器软件，推荐软件：Google Authenticator、Microsoft Authenticator、Authy 等
                    li 打开 TOTP 软件，扫描上方二维码
                    li 在下方输入软件显示的 6 位数字动态码，点击"{{ bindMode === 'anon' ? '绑定并登录' : '绑定并进入系统' }}"按钮
            el-input(ref="bindCodeInput", v-model="bindCode", maxlength="6", placeholder="请输入扫码后认证器显示的 6 位动态码", @input="onBindCodeInput", @keyup.enter.native="submitBind")
            .mfa-warn 动态码每 30 秒刷新一次；若多次提示不正确，请检查手机时间是否开启自动同步
            span(slot="footer")
                el-button(type="text", :disabled="bindRefreshing || bindLoading", @click="refreshBindSetup") 刷新二维码
                el-button(type="primary", :loading="bindLoading", @click="submitBind") {{ bindMode === 'anon' ? '绑定并登录' : '绑定并进入系统' }}
</template>

<script>
/* eslint-disable */
// 动态背景js
// require("particles.js");
import config from './config/default'
import { mapActions } from 'vuex'
import util from '@/libs/util.js'
import { getPermissions } from '@/util'
const Base64 = require('js-base64').Base64
export default {
  data() {
    return {
      // 快速选择用户
      dialogVisible: false,
      users: [
        {
          name: '管理员',
          username: 'admin',
          password: 'admin'
        },
        {
          name: '编辑',
          username: 'editor',
          password: 'editor'
        },
        {
          name: '用户1',
          username: 'user1',
          password: 'user1'
        }
      ],
      // 表单
      formLogin: {
        username: '',
        password: '',
        remember: '',
        uuid: '',
        code: ''
      },
      // 校验
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      captchaPath: '',
      submitLoading: false,
      // 二次认证弹窗（已绑定用户）：验码换 token
      mfaVisible: false,
      mfaLoading: false,
      mfaCode: '',
      // 首次绑定弹窗（未绑定用户）：扫码 → 动态码 → 绑定+登录一步完成
      bindVisible: false,
      bindLoading: false,
      bindRefreshing: false,
      bindCode: '',
      bindInfo: { otpauthUri: '', qrCode: '' },
      // 绑定提交模式：auth-登录态 /sys/mfa/enable；anon-匿名二阶段 /sys/login/mfa/bind（每次重验账密）
      bindMode: 'auth'
    }
  },
  created() {
    //this.getCookie();
    this.formLogin.username = util.cookies.get('username')
    this.formLogin.password = util.cookies.get('password')
    this.getCaptcha()
  },
  mounted() {
    // 初始化例子插件
    //particlesJS("login", config);
  },
  beforeDestroy() {
    // 销毁 particlesJS
    // thanks https://github.com/d2-projects/d2-admin/issues/65
    // ref https://github.com/VincentGarreau/particles.js/issues/63
    //if (pJSDom && pJSDom.length > 0) {
    //  pJSDom[0].pJS.fn.vendors.destroypJS();
    // pJSDom = [];
    //}
  },
  methods: {
    ...mapActions('d2admin/account', ['login']),
    ...mapActions('d2admin/page', ['closeAll']),

    /**
     * 获取uuid
     */
    getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        return (c === 'x'
          ? (Math.random() * 16) | 0
          : 'r&0x3' | '0x8'
        ).toString(16)
      })
    },
    // 获取验证码
    getCaptcha() {
      this.formLogin.uuid = this.getUUID()
      this.captchaPath = this.$http.adornUrl(
        `/captcha.jpg?uuid=${this.formLogin.uuid}`
      )
    },
    /**
     * @description 接收选择一个用户快速登录的事件
     * @param {Object} user 用户信息
     */
    handleUserBtnClick(user) {
      this.formLogin.username = user.username
      this.formLogin.password = user.password
      this.submit()
    },
    /* setCookie(c_name, c_pwd, exdays) {
                 var exdate = new Date();
                 exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
                 document.cookie = "userName=" + c_name + ";path=/;expires=" + exdate.toLocaleString()
                 document.cookie = "userPwd=" + c_pwd + ";path=/;expires=" + exdate.toLocaleString()
             },
             //获取cookie
             getCookie: function() {
                 if (document.cookie.length > 0) {
                     var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
                     // console.log(arr)
                     for (var i = 0; i < arr.length; i++) {
                         var arr2 = arr[i].split('='); //再次切割
                         //判断查找相对应的值
                         if (arr2[0] == 'userName') {
                             this.formLoginusername = arr2[1]; //保存到保存数据的地方
                         } else if (arr2[0] == 'userPwd') {
                             this.formLogin.password = arr2[1];
                         }
                     }
                 }
             },
             //删除cookie
             clearCookie: function() {
                 this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了

             },*/
    /**
     * @description 提交表单
     */
    // 提交登录信息
    clearCookie: function() {
      util.cookies.set('username', '')
      util.cookies.set('password', '')
    },
    submit() {
      // 登录关闭所有tab
      this.closeAll()
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // this.login({
          //    vm: this,
          //    username: this.formLogin.username,
          //    password: this.formLogin.password,
          //    uuid: this.formLogin.uuid,
          //    captcha: this.formLogin.code
          // })
          // 先进行认证
          // 获取数据列表
          this.submitLoading = true
          this.$http({
            url: this.$http.authUrl('/oauth/token'),
            method: 'post',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: {
              grant_type: 'captcha',
              username: this.formLogin.username,
              password: this.formLogin.password,
              scope: 'all',
              captchaCode: this.formLogin.code,
              uuid: this.formLogin.uuid
            }
          })
            .then((data) => {
              if (data.access_token) {
                // 登录
                // 注意 这里的演示没有传验证码
                // 具体需要传递的数据请自行修改代码
                util.cookies.set('authorization', data.access_token)

                this.$http({
                  url: this.$http.adornUrl('/sys/login'),
                  method: 'post',
                  // 登录一阶段为匿名接口，不携带 Authorization/token 请求头
                  noAuthHeader: true,
                  data: {
                    uuid: this.formLogin.uuid,
                    username: this.formLogin.username,
                    password: this.formLogin.password,
                    captcha: this.formLogin.code
                  }
                })
                  .then((res) => {
                    this.submitLoading = false
                    if (!res) {
                      // 业务失败（msg 已由拦截器统一提示）：刷新图形验证码等待重试
                      this.getCaptcha()
                      return
                    }
                    // 强制模式且未绑定：携账密调 /sys/login/mfa/setup 取二维码，扫码后携账密+动态码绑定并登录
                    if (!res.token && res.mfaBindRequired === true) {
                      this.bindMode = 'anon'
                      this.bindVisible = true
                      this.refreshBindSetup()
                      return
                    }
                    // 已绑定用户：一阶段不发 token，弹二次认证动态码弹窗（携账密+动态码换 token）
                    if (!res.token && res.mfaRequired === true) {
                      this.mfaCode = ''
                      this.mfaVisible = true
                      this.focusMfaInput()
                      return
                    }
                    // 登录成功拿到 token（mfa.required=false 且未绑定）：落登录态 → 查绑定状态决定放行或补绑
                    if (res.token) {
                      this.afterLoginSuccess(res)
                    } else {
                      // 兜底：无 token 也无 MFA 标记，回到登录表单
                      this.$message.error('登录响应异常，请重试')
                      this.getCaptcha()
                    }
                  })
                  .catch((err) => {
                    this.submitLoading = false
                    this.getCaptcha()
                  })
              } else {
                this.submitLoading = false
              }
            })
            .catch((err) => {
              this.submitLoading = false
              this.getCaptcha()
            })
        } else {
          // 登录表单校验失败
          //  this.$message.error("表单校验失败");
        }
      })
    },
    /**
     * @description 登录成功后统一处理：先落登录态，再查 TOTP 绑定状态决定放行或弹绑定向导
     */
    afterLoginSuccess(res) {
      // 设置 cookie 一定要存 uuid 和 token 两个 cookie
      // 整个系统依赖这两个数据进行校验和存储
      // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
      // token 代表用户当前登录状态 建议在网络请求中携带 token
      util.cookies.set('uuid', res.uuid)
      util.cookies.set('token', res.token)
      // 存储登陆用户权限信息
      sessionStorage.setItem('permissions', res.permissions)
      // 设置 vuex 用户信息
      this.$store.dispatch(
        'd2admin/user/set',
        {
          name: this.formLogin.username
        },
        { root: true }
      )
      // 用户登录后从持久化数据加载一系列的设置
      this.$store.dispatch('d2admin/account/load')
      // 获取最新权限信息（注册动态路由，进入首页依赖）
      getPermissions()
      // 强制二次认证：登录态下查询绑定状态，未绑定先扫码绑定，绑定完成才进入系统
      this.checkMfaBind()
    },
    /**
     * @description 查询当前用户 TOTP 绑定状态（GET /sys/mfa/status，需登录）
     */
    checkMfaBind() {
      this.$http({
        url: this.$http.adornUrl('/sys/mfa/status'),
        method: 'get'
      })
        .then((res) => {
          if (res && res.enabled) {
            // 已绑定：直接进入系统
            this.navigateAfterLogin()
          } else {
            // 未绑定：登录态下生成绑定密钥与二维码，强制完成绑定
            this.openBindWizard()
          }
        })
        .catch(() => {
          // 状态查询异常时不阻断登录，按已绑定放行（避免 MFA 服务异常导致全局无法登录）
          this.navigateAfterLogin()
        })
    },
    /**
     * @description 绑定向导第一步：POST /sys/mfa/setup（需登录，无请求参数，身份从 Authorization 解析）
     */
    openBindWizard() {
      this.bindMode = 'auth'
      this.bindVisible = true
      this.refreshBindSetup()
    },
    /**
     * @description 跳转进入系统（绑定完成/已绑定/状态查询异常放行共用）
     */
    navigateAfterLogin() {
      // 更新路由 尝试去获取 cookie 里保存的需要重定向的页面完整地址
      const path = util.cookies.get('redirect')
      // 根据是否存有重定向页面判断如何重定向
      this.$router.replace(path ? { path } : { name: 'index' })
      // 删除 cookie 中保存的重定向页面
      util.cookies.remove('redirect')

      if (this.formLogin.remember) {
        util.cookies.set('username', this.formLogin.username)
        util.cookies.set('password', this.formLogin.password)
      } else {
        this.clearCookie()
      }
    },
    /**
     * @description 二次认证弹窗提交（登录二阶段，匿名接口）：验码换 token
     */
    submitMfa() {
      const code = (this.mfaCode || '').trim()
      if (!/^\d{6}$/.test(code)) {
        this.$message.error('请输入 6 位数字动态码')
        return
      }
      this.mfaLoading = true
      this.$http({
        url: this.$http.adornUrl('/sys/login/mfa'),
        method: 'post',
        // 匿名接口：不携带 Authorization/token 请求头
        noAuthHeader: true,
        // 失败时把业务错误 reject 出来，便于读取 msg 分支处理
        rawError: true,
        // 二阶段每次重新校验账密：携一阶段表单账密 + 动态码
        data: {
          username: this.formLogin.username,
          password: this.formLogin.password,
          totpCode: code
        }
      })
        .then((res) => {
          this.mfaLoading = false
          this.mfaVisible = false
          this.afterLoginSuccess(res)
        })
        .catch((err) => {
          this.mfaLoading = false
          const msg = err && err.message ? err.message : ''
          // 二阶段账密校验失败：回到账密登录（图形验证码已被一阶段消费，刷新后重输）
          if (/账号或密码不正确/.test(msg)) {
            this.mfaVisible = false
            this.getCaptcha()
          } else {
            // 动态码错误/锁定：msg 已由拦截器提示，留在弹窗清码等待重试
            this.mfaCode = ''
            this.focusMfaInput()
          }
        })
    },
    /**
     * @description 绑定提交：auth 模式走登录态 /sys/mfa/enable；anon 模式走匿名 /sys/login/mfa/bind（每次重验账密，绑定+登录一步完成）
     */
    submitBind() {
      const code = (this.bindCode || '').trim()
      if (!/^\d{6}$/.test(code)) {
        this.$message.error('请输入 6 位数字动态码')
        return
      }
      const useAnon = this.bindMode === 'anon'
      this.bindLoading = true
      this.$http({
        url: this.$http.adornUrl(useAnon ? '/sys/login/mfa/bind' : '/sys/mfa/enable'),
        method: 'post',
        // anon 模式为登录二阶段匿名接口，不携带 Authorization/token 请求头
        noAuthHeader: useAnon,
        // 失败时读取 msg 分支处理（绑定会话过期换码 / 账密错误回账密登录）
        rawError: true,
        data: useAnon
          ? {
              username: this.formLogin.username,
              password: this.formLogin.password,
              totpCode: code
            }
          : { totpCode: code }
      })
        .then((res) => {
          this.bindLoading = false
          this.bindVisible = false
          this.$message.success('二次认证绑定成功')
          if (useAnon) {
            // 绑定+登录一步完成：响应含 token，落登录态后进入系统
            this.afterLoginSuccess(res)
          } else {
            this.navigateAfterLogin()
          }
        })
        .catch((err) => {
          this.bindLoading = false
          const msg = err && err.message ? err.message : ''
          if (/绑定会话已过期/.test(msg)) {
            // 暂存密钥过期（10min）：携账密重新获取二维码
            this.$message.warning('二维码已过期，已为你刷新，请重新扫码')
            this.refreshBindSetup()
          } else if (useAnon && /账号或密码不正确/.test(msg)) {
            // 二阶段账密校验失败：关闭弹窗回账密重新登录
            this.bindVisible = false
            this.getCaptcha()
          } else {
            // 动态码错误/锁定：msg 已由拦截器提示，留在弹窗清码等待重试
            this.bindCode = ''
            this.focusBindInput()
          }
        })
    },
    /**
     * @description 生成/刷新绑定二维码：auth 模式 POST /sys/mfa/setup（需登录，无参数）；
     *              anon 模式 POST /sys/login/mfa/setup（匿名，携账密重新校验后发码）
     */
    refreshBindSetup() {
      const useAnon = this.bindMode === 'anon'
      this.bindRefreshing = true
      this.$http({
        url: this.$http.adornUrl(useAnon ? '/sys/login/mfa/setup' : '/sys/mfa/setup'),
        method: 'post',
        noAuthHeader: useAnon,
        rawError: useAnon,
        data: useAnon
          ? { username: this.formLogin.username, password: this.formLogin.password }
          : undefined
      })
        .then((res) => {
          this.bindRefreshing = false
          if (!res) return
          this.bindInfo = {
            otpauthUri: res.otpauthUri || '',
            qrCode: res.qrCode || ''
          }
          this.bindCode = ''
          this.focusBindInput()
        })
        .catch((err) => {
          this.bindRefreshing = false
          const msg = err && err.message ? err.message : ''
          // 二阶段账密校验失败：关闭弹窗回账密重新登录
          if (useAnon && /账号或密码不正确/.test(msg)) {
            this.bindVisible = false
            this.getCaptcha()
          }
        })
    },
    resetBind() {
      this.bindCode = ''
      this.bindInfo = { otpauthUri: '', qrCode: '' }
      this.bindMode = 'auth'
      // 关闭绑定向导回到账密登录：一阶段图形验证码已被消费，刷新后重输
      this.getCaptcha()
    },
    /**
     * @description 仅保留数字，最长 6 位（支持直接粘贴完整动态码）
     */
    onMfaCodeInput(val) {
      this.mfaCode = String(val || '').replace(/\D/g, '').slice(0, 6)
    },
    onBindCodeInput(val) {
      this.bindCode = String(val || '').replace(/\D/g, '').slice(0, 6)
    },
    focusMfaInput() {
      this.$nextTick(() => {
        if (this.$refs.mfaInput) {
          this.$refs.mfaInput.focus()
        }
      })
    },
    focusBindInput() {
      this.$nextTick(() => {
        if (this.$refs.bindCodeInput) {
          this.$refs.bindCodeInput.focus()
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';

.el-card__body .el-input__inner {
  font-size: 14px;
  padding: 0 24px;
  border-radius: 0;
}

.el-card__body .authCode-input .el-input__inner {
  transform: translateX(-42px) !important;
}

// 二次认证 / 绑定弹窗
.mfa-dialog-tip {
  margin: 0 0 14px;
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}

.mfa-qrcode {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;

  img {
    width: 180px;
    height: 180px;
  }
}

// 绑定弹窗使用说明（参照扫描二维码引导样式）
.mfa-guide {
  margin: 0 0 14px;
  padding: 12px 16px;
  background: #f0f9eb;
  border-left: 4px solid #67c23a;
  border-radius: 4px;

  .mfa-guide-title {
    margin-bottom: 8px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #67c23a;
  }

  .mfa-guide-list {
    margin: 0;
    padding-left: 20px;
    font-size: 13px;
    color: #606266;
    line-height: 1.8;

    li {
      word-break: break-all;
    }
  }
}

.mfa-warn {
  margin: 10px 0 0;
  font-size: 12px;
  color: #e6a23c;
  line-height: 1.5;
}

</style>